/**
 * Frontend feature flags — hardcoded on/off toggles for UI features.
 * These are distinct from backend org-level feature flags (enabled_features bitmask).
 * These are only used in the short term for prototyping before the feature is added to the backend feature flags.
 */
export const featureFlags = {
  orgSwitcher: false
} as const
